import { render, staticRenderFns } from "./EditTaxonomyGenus.vue?vue&type=template&id=76d1a276&"
import script from "./EditTaxonomyGenus.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyGenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports